<template>
  <div>
    <b-row>
      <b-col cols="10">
        <b-form-group label="Nome:">
          <b-form-input
            v-model="user.name"
            placeholder="Nome"
            :state="validateState('name')"
          ></b-form-input>
          <b-form-invalid-feedback
            >Nome é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Status:">
          <b-form-checkbox v-model="user.ativo" value="1" unchecked-value="0">
            Ativo
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="E-mail:">
      <b-form-input
        v-model="user.email"
        placeholder="E-mail"
        :state="validateState('email')"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.user.email.required"
          >E-mail é um campo obrigatório.</span
        >
        <span v-if="!$v.user.email.email">E-mail inválido</span>
        <span v-if="!$v.user.email.serverFailed">
          <span
            v-for="message in $v.user.email.$params.serverFailed.message"
            :key="message"
          >
            {{ $t(message) }}
          </span>
        </span>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Cliente:">
      <div class="d-flex">
        <div style="width: 95%">
          <select-cliente
            v-model="user.cliente_id"
            :state="validateState('cliente_id')"
            ref="selectCliente"
            size="md"
          />
          <b-form-invalid-feedback :state="validateState('cliente_id')">
            Cliente é um campo obrigatório.
          </b-form-invalid-feedback>
        </div>
        <div
          @click="
            $router.push({
              name: 'clientes_edit',
              params: { id: user.cliente_id },
            })
          "
          class="ml-2 link-user cursor-pointer table-actions"
        >
          <b-button variant="outline-exitos"
            ><font-awesome-icon icon="far fa-edit"
          /></b-button>
        </div>
      </div>
    </b-form-group>

    <b-form-group label="Senha:">
      <b-form-input
        v-model="user.password"
        :state="validateState('password')"
        placeholder="Senha"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.user.password.minLength"
          >Password requer um mínimo de 6 caracteres.</span
        >
      </b-form-invalid-feedback>
      <b-form-text id="input-live-help" v-if="user.id"
        >Deixe em branco para não alterar.</b-form-text
      >
    </b-form-group>
    <b-form-group label="Confirmar Senha:">
      <b-form-input
        v-model="user.password_confirmation"
        :state="validateState('password_confirmation')"
        placeholder="Confirmar senha"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.user.password_confirmation.sameAsPassword"
          >Confirmação está diferente da senha.</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Papeis:">
      <b-form-checkbox-group v-model="selected_roles" name="roles" v-if="roles">
        <b-row v-for="(role, key) in roles" :key="'roles-' + key">
          <b-col>
            <b-form-checkbox :value="role.id">{{ role.name }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  requiredIf,
  helpers,
} from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data: () => ({
    roles: null,
    cliente: null,
    serverError: false,
  }),
  validations: {
    user: {
      name: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
        serverFailed: helpers.withParams({ message: [] }, function (value, vm) {
          return !this.serverError;
        }),
      },
      cliente_id: {
        required,
      },
      password: {
        required: requiredIf(function (user) {
          return user.id ? false : true;
        }),
        minLength: minLength(6),
      },
      password_confirmation: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    ...mapState("users", ["user"]),
    selected_roles: {
      set(ids) {
        let roles = [];

        ids.forEach((id) => {
          let role = _.find(this.roles, ["id", id]);
          if (role) {
            roles.push(role);
          }
        });

        this.user.roles = roles;
      },
      get() {
        let roles = [];
        this.user.roles.forEach((role) => {
          roles.push(role.id);
        });

        return roles;
      },
    },
  },
  methods: {
    ...mapActions("acl", ["ActionFind"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      if (!this.user.password) {
        delete this.user.password;
      }

      if (!this.user.password_confirmation) {
        delete this.user.password_confirmation;
      }

      this.$v.user.$touch();
      return !this.$v.user.$anyError;
    },
    hasServerError(field) {
      return field && this.serverError;
    },
  },
  watch: {
    "user.cliente.id": {
      handler: function (value, old) {
        this.user.cliente_id = value;
      },
    },
  },
  async created() {
    let response_roles = await this.ActionFind({ per_page: 30 });
    this.roles = response_roles.data;
  },
};
</script>
<style scoped>
.link-user {
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
